import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "flex-fill d-flex slot-wrapper" }

import {computed, provide} from "vue";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import useActivated from "~/ts/vuePlugins/useActivated";


const __default__ = {
    name: "OperatorApplicationSection"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isSectionSelected: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let isActivated = useActivated();

provide(isInSelectedSectionInjectionKey, computed(() => props.isSectionSelected && isActivated.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})